const EXPLICIT_LOGIN_INTENT_KEY = "yb_explicit_login_intent";
const EXPLICIT_LOGIN_INTENT_TTL_MS = 10 * 60 * 1000;
export const EXPLICIT_LOGIN_CONFIRMED_EVENT = "yb:explicit-login-confirmed";
let confirmedPasswordSession = null;
let correlationRequired = false;

export function setExplicitLoginCorrelationRequired(required) {
  correlationRequired = required === true;
}

export function isExplicitLoginCorrelationRequired() {
  return correlationRequired;
}

function canUseSessionStorage() {
  return typeof window !== "undefined" && Boolean(window.sessionStorage);
}

export function beginExplicitLoginIntent(kind) {
  if (!canUseSessionStorage()) return;
  const id =
    typeof globalThis.crypto?.randomUUID === "function"
      ? globalThis.crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  const intent = {
    id,
    // This marker deliberately contains no user, session, or token data.
    kind: kind === "oauth" ? "oauth" : "password",
    issuedAt: Date.now(),
  };
  try {
    window.sessionStorage.setItem(
      EXPLICIT_LOGIN_INTENT_KEY,
      JSON.stringify(intent)
    );
    return intent;
  } catch {
    // Login remains available when storage is unavailable.
  }
}

export function consumeExplicitLoginIntent(expectedId = null) {
  if (!canUseSessionStorage()) return null;
  try {
    const raw = window.sessionStorage.getItem(EXPLICIT_LOGIN_INTENT_KEY);
    const intent = raw ? JSON.parse(raw) : null;
    if (!intent || !Number.isFinite(intent.issuedAt) || typeof intent.id !== "string") return null;
    if (Date.now() - intent.issuedAt > EXPLICIT_LOGIN_INTENT_TTL_MS) return null;
    if (expectedId && intent.id !== expectedId) return null;
    if (intent.kind !== "oauth" && intent.kind !== "password") return null;
    window.sessionStorage.removeItem(EXPLICIT_LOGIN_INTENT_KEY);
    return intent;
  } catch {
    return null;
  }
}

export function clearExplicitLoginIntent(expectedId = null) {
  if (!canUseSessionStorage()) return;
  try {
    if (!expectedId) {
      window.sessionStorage.removeItem(EXPLICIT_LOGIN_INTENT_KEY);
      return;
    }
    const intent = JSON.parse(window.sessionStorage.getItem(EXPLICIT_LOGIN_INTENT_KEY) || "null");
    if (intent?.id === expectedId) window.sessionStorage.removeItem(EXPLICIT_LOGIN_INTENT_KEY);
  } catch {
    // best effort
  }
}

export function confirmExplicitPasswordLogin(intent, session) {
  if (!intent?.id || !session?.user) return false;
  const stored = consumeExplicitLoginIntent(intent.id);
  if (!stored || stored.kind !== "password") return false;
  confirmedPasswordSession = session;
  window.dispatchEvent(new CustomEvent(EXPLICIT_LOGIN_CONFIRMED_EVENT));
  return true;
}

export function consumeConfirmedPasswordSession() {
  const session = confirmedPasswordSession;
  confirmedPasswordSession = null;
  return session;
}
